// extracted by mini-css-extract-plugin
var _1 = "label-color___uPVse";
export { _1 as "label-color" }
